import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import ellipsis from "./directives/ellipsis";
import globalVars from "../config/index";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.directive("ellipsis", ellipsis);
// 全局配置 axios
Vue.prototype.$http = axios;
// 挂载到 Vue 原型，这样在任何组件中都可以通过 this.$global 访问
Vue.prototype.$global = globalVars;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
